import adManager from "./admob";
import { getEventParams, logEvent } from "./analytics";
import { LOOSE_LIFE_RECOVERY_TIME, NUM_LIVES_WAIT } from "./config";
import { throwErrorWithStack } from "./crashlytics";
import {
  livesCounterEl,
  noLivesEl,
  noLivesElCtaContainer,
  waitTimerEl,
} from "./elements";
import { getLogger } from "./logging";
import { stack } from "./nav";
import { showSuccessSnackbar } from "./snackbar";
import store from "./store";

const log = getLogger("🧡 Lives")

// const createLife = function () {
// //   const imgEl = document.createElement("img");
// //   imgEl.setAttribute("src", "img/cat.svg");
// //   imgEl.style.width = "6vmin";
// //   imgEl.style.marginRight = "1.2vmin";
// //   livesEl.appendChild(imgEl);
//   {
//     /* <img src="img/cat-01.svg"
//                     style="max-width: 100%; max-height: calc(min(100vh - 142vmin, 22vmax));display:block;margin:auto;border-radius:3vmin;margin-top:3vmin;margin-bottom:-17vmin"></img> */
//   }
// };

export function updateLives() {
  livesCounterEl.innerHTML = store.numLives;
  //   if (livesEl.children.length != store.numLives) {
  //     // livesEl.innerHTML = "";
  //     if (store.numLives)
  //       for (const i of [...Array(store.numLives).keys()]) createLife(i);
  //   }
}

export const loseLife = function () {
  if (store.levelIdx == store.maxLevelIdx)
    store.set("numLives", Math.max(store.numLives - 1, 0));
  updateLives();
  //   if (livesEl.children.length) livesEl.removeChild(livesEl.lastChild);
  store.set("lastLifeLostDate", new Date());
  setTimeout(handleLivesModal, 1500);
};

export function livesFromTimeDelta() {
  const now = new Date();
  const millis = now - store.lastLifeLostDate;
  const seconds = millis / 1000;
  const extraLives =
    Math.floor(seconds / LOOSE_LIFE_RECOVERY_TIME) * NUM_LIVES_WAIT;
  if (extraLives) store.set("lastLifeLostDate", now);
  const numLivesNew = Math.max(
    store.numLives,
    Math.min(9, extraLives + store.numLives)
  );
  const numNewLives = numLivesNew - store.numLives;
  log.info(`Got ${numNewLives} lives back`);
  if (numNewLives) incrementLives(numNewLives);
}

let timerInterval = null;

export const handleLivesModal = () => {
  if (store.numLives > 0) {
    if (store.screenName == "no_lives_modal") stack.pop();
    noLivesEl.classList.remove("visible");
    noLivesElCtaContainer.classList.remove("visible");
  } else {
    stack.push("no_lives_modal");
    noLivesEl.classList.add("visible");
    noLivesElCtaContainer.classList.add("visible");
    if (timerInterval != null) clearInterval(timerInterval);
    if (!setTimeLeft()) timerInterval = setInterval(setTimeLeft, 1000);
  }
};

function setTimeLeft() {
  const now = new Date();
  const millis = now - store.lastLifeLostDate;
  const secondsLeft = Math.max(0, LOOSE_LIFE_RECOVERY_TIME - millis / 1000);
  // set time left, in formtat mm:ss
  waitTimerEl.innerHTML = new Date(secondsLeft * 1000)
    .toISOString()
    .slice(14, 19);
  if (secondsLeft == 0) {
    clearInterval(timerInterval);
    showSuccessSnackbar(
      NUM_LIVES_WAIT == 1
        ? "You got a life back! 🎉"
        : `You got ${NUM_LIVES_WAIT} lives back! 🎉`
    );
    incrementLives(NUM_LIVES_WAIT);
    return true;
  }
}

export function incrementLives(lives = 1) {
  if (!lives) {
    log.warn("No lives to increment");
    return;
  }
  logEvent("increment_lives", { lives, ...getEventParams() });
  store.set("numLives", store.numLives + lives);
  updateLives();
  handleLivesModal();
}

if (__DEV__) window.incrementLives = incrementLives;

export async function earnLive(AdMob) {
  try {
    await adManager.showAd(AdMob, "Reward");
  } catch (error) {
    throwErrorWithStack(error, true);
  } finally {
    try {
      await adManager.prepareAd(AdMob, "Reward");
    } catch (error) {
      if (error.message == "No fill.") {
        log.error(error);
      } else throwErrorWithStack(error);
    }
  }
}
